import Component from "./PuppyLeafPartyLeaderboard";

export default Component;
